import board from './board';
import article from './article';
import contract from './contract'

export default{
    board,
    article,
    contract
}